import React, { ReactElement } from 'react';
import Avatar from '@material-ui/core/Avatar';
import Button, { ButtonProps } from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import { useForm } from 'react-hook-form';
import Paper from '@material-ui/core/Paper';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import useStyles from './styles';
import LockIcon from '@material-ui/icons/Lock';
import NavigationConfig from 'navigation/config';
import { Link } from 'react-router-dom';
import { TranslatedTextV2 } from 'components/atoms/TranslatedText';
import { useDispatch } from 'react-redux';
import Actions from 'redux/reducers/gl_auth_reducer/actions';
import { IconButton, InputAdornment } from '@material-ui/core';
import { AccountCircle } from '@material-ui/icons';
import * as AuthSelectors from 'redux/reducers/gl_auth_reducer/selectors';
import { StateStatus } from 'redux/utils/common';
import FormFeedback from 'components/molecules/FormFeedback';
import * as HostSelectors from 'redux/reducers/gl_host_provider/selectors';
import environment from 'config/environment';
import { TranlsationKey } from '../../configuration';
import {
  GoogleAuthButton,
  FacebookAuthButton,
  AppleAuthButton,
} from 'components/atoms/AuthLoginButtons';
import { socialLogin } from 'services/api/authenticate';
import LoadingView from 'components/atoms/LoadingView';

function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {'Copyright © '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}

export default function LoginForm(): ReactElement {
  const classes = useStyles();
  const {
    register,
    formState: { errors },
    handleSubmit,
  } = useForm();
  const dispatch = useDispatch();
  const logo = HostSelectors.useHostLogo();

  const onSubmit = (data: any) => {
    // console.log('Data:', data);
    dispatch(
      Actions.authenticateAction({
        email: data.email,
        password: data.password,
        stayLogin: Boolean(data.rememberMe),
      })
    );
  };

  return (
    <>
      <LoginLoading />
      <div>
        <form
          onSubmit={handleSubmit(onSubmit)}
          className={classes.form}
          noValidate
        >
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            id="email"
            label={
              <TranslatedTextV2
                defaultText="Email"
                translationKey={`${TranlsationKey}.email`}
              />
            }
            // name="email"
            autoComplete="email"
            error={'email' in errors}
            // helperText={errorSelector('email')}
            {...register('email', {
              required: true,
              pattern: {
                value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                message: 'Invalid email format',
              },
            })}
            autoFocus
            InputProps={{
              endAdornment: (
                <InputAdornment position="start">
                  <AccountCircle />
                </InputAdornment>
              ),
            }}
          />
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            // name="password"
            label={
              <TranslatedTextV2
                defaultText="Password"
                translationKey={`${TranlsationKey}.password`}
              />
            }
            type="password"
            id="password"
            {...register('password', { required: 'Required' })}
            error={'password' in errors}
            // helperText={errorSelector('password')}
            autoComplete="current-password"
            InputProps={{
              endAdornment: (
                <InputAdornment position="start">
                  <LockIcon />
                </InputAdornment>
              ),
            }}
          />
          {/* <WrongCrentetialsMessage /> */}
          <Grid alignItems={'center'} container>
            <Grid item xs>
              <FormControlLabel
                control={<Checkbox value="remember" color="primary" />}
                label="Remember Me"
                name={'rememberMe'}
                // inputRef={register({ required: true })}
              />
            </Grid>
            <Grid item>
              <Link
                to={NavigationConfig.forgotPasswordPage().path}
                style={{ color: 'inherit' }}
              >
                <TranslatedTextV2
                  defaultText="Forgot Password?"
                  translationKey={`${TranlsationKey}.forgot`}
                />
              </Link>
            </Grid>
          </Grid>

          <Box
            display={'flex'}
            flexDirection="column"
            alignItems={'center'}
            justifyContent={'center'}
          >
            <SubmitWrapper
              type="submit"
              fullWidth
              variant="contained"
              color="secondary"
              className={classes.submit}
              buttonType="email"
            >
              <TranslatedTextV2
                defaultText="Login"
                translationKey={`${TranlsationKey}.login`}
              />
            </SubmitWrapper>

            {/* <Typography
              variant="h5"
              style={{ margin: '1rem', textAlign: 'center', fontSize: 11.5 }}
            >
              <TranslatedTextV2
                defaultText="Alternatively"
                translationKey={`${TranlsationKey}.alternativeSignin`}
              />
              <Typography style={{ textAlign: 'center', fontSize: 11.5 }}>
                <TranslatedTextV2
                  defaultText="use one of these methods to sign in"
                  translationKey={`${TranlsationKey}.alternativeSignin`}
                />
              </Typography>
            </Typography> */}
            {/* <SubmitWrapper
              onClick={() => socialLogin('google')}
              buttonType="google"
              // onClick={() => {
              //   window.location =
              //     `${environment.API_BASE_URL}/api/oauth/google/login` as any;
              // }}
            >
              <TranslatedTextV2
                defaultText="Login wth Google"
                translationKey={`${TranlsationKey}.google`}
              />
            </SubmitWrapper> */}
            {/* <SubmitWrapper
              onClick={() => socialLogin('facebook')}
              buttonType="facebook"
            >
              <TranslatedTextV2
                defaultText="Login with Facebook"
                translationKey={`${TranlsationKey}.facebook`}
              />
            </SubmitWrapper> */}
          </Box>
        </form>
      </div>
    </>
  );
}

interface IButtonProps extends ButtonProps {
  buttonType: 'facebook' | 'apple' | 'google' | 'email';
}

const LoginLoading = () => {
  const authStatus = AuthSelectors.useSelectAuthStatus();

  return (
    <>{StateStatus.Pending === authStatus && <LoadingView fullScreen />}</>
  );
};

const SubmitWrapper = ({ buttonType, ...props }: IButtonProps) => {
  // const authStatus = AuthSelectors.useSelectAuthStatus();
  return (
    <React.Fragment>
      {buttonType === 'apple' && (
        <AppleAuthButton
          {...props}
          // disabled={StateStatus.Pending === authStatus}
          text={props.children}
        />
      )}
      {buttonType === 'google' && (
        <GoogleAuthButton
          {...props}
          // disabled={StateStatus.Pending === authStatus}
          text={props.children}
        />
      )}
      {buttonType === 'facebook' && (
        <FacebookAuthButton
          {...props}
          // disabled={StateStatus.Pending === authStatus}
          text={props.children}
        />
      )}
      {buttonType === 'email' && (
        <Button
          {...props}
          color="secondary"
          // disabled={StateStatus.Pending === authStatus}
        />
      )}
    </React.Fragment>
  );
};
